module.exports = __webpack_public_path__ + "static/media/2_mustache_Kokuryeo_Korean_Subak_frontal_slap.ce95716f.jpg";